// filepath: /Users/sjuul/workspace/robust-risk/frontend/src/store/apiKey/apiKeySlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store.ts';
import { APIKey } from '../../models/apiKey.ts';

interface APIKeyState {
  api_keys: APIKey[];
}

const initialState: APIKeyState = {
  api_keys: [],
};

const apiKeySlice = createSlice({
  name: 'apiKey',
  initialState,
  reducers: {
    setAPIKeys(state, action: PayloadAction<APIKey[]>) {
      state.api_keys = action.payload;
    },
    addAPIKey(state, action: PayloadAction<APIKey>) {
      state.api_keys.push(action.payload);
    },
    updateAPIKey(state, action: PayloadAction<APIKey>) {
      const index = state.api_keys.findIndex((k: APIKey) => k.id === action.payload.id);
      if (index !== -1) state.api_keys[index] = action.payload;
    },
    removeAPIKey(state, action: PayloadAction<number>) {
      state.api_keys = state.api_keys.filter((k: APIKey) => k.id !== action.payload);
    },
  },
});

export const { setAPIKeys, addAPIKey, updateAPIKey, removeAPIKey } = apiKeySlice.actions;
export const selectAPIKeys = (state: RootState) => state.apiKey.api_keys;
export default apiKeySlice.reducer;

